import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { NgIf } from '@angular/common';
import { MrsBtnTertiaryComponent } from '@Shared/components/mrs-buttons/mrs-btn-tertiary/mrs-btn-tertiary.component';
import { ConfirmationDialogMessageMode, MrsColor } from 'app/enums';

export interface ConfirmationDialogData {
    title?: string;
    message: string;
    messageMode?: ConfirmationDialogMessageMode;
    key?: string;
    onOk?: () => void;
    accept?: () => void;
    reject?: () => void;
    onCancel?: () => void;
    onClose?: () => void;
    okLabel?: string;
    cancelLabel?: string;
    showCancel?: boolean;
    cancelTextColor?: MrsColor;
    okTextColor?: MrsColor;
    isDestructive?: boolean;
    focusOkOnOpen?: boolean;
}

@Component({
    selector: 'confirmation-dialog',
    templateUrl: 'confirmation-dialog.html',
    imports: [NgIf, MatDialogModule, MrsBtnTertiaryComponent]
})
export class ConfirmationDialogComponent {
    messageMode = ConfirmationDialogMessageMode;

    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData) {
        this.data.title = this.data.title || 'Confirm';
        this.data.okLabel = this.data.okLabel || 'Ok';
        this.data.cancelLabel = this.data.cancelLabel || 'Cancel';
        this.data.messageMode = this.data.messageMode || ConfirmationDialogMessageMode.Text;
    }

    onOk(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }

    accept(): void {
        this.dialogRef.close(true);
    }

    reject(): void {
        this.dialogRef.close(false);
    }
}
